import { message } from "antd";
import OrderApi from "../../api/orderApi";
import {
  loginFail,
  loginPending,
  loginSuccess,
  logoutSuccess,
} from "../reducerSlice/isAuthSlice";

import {
  userOrderFail,
  userOrderPending,
  userOrderSuccess,
  searchOrderSuccess,
  resetOrderSuccess,
  deleteOrderSuccess,
  updateDateOrderSuccess,
} from "../reducerSlice/UserOrderSlice";

export const UserLogout = () => async (dispatch) => {
  await dispatch(loginPending());

  await dispatch(logoutSuccess());
  OrderApi.logOutUser();
};

export const UserLogin = (payload) => async (dispatch) => {
  await dispatch(loginPending());
  const res = await OrderApi.orderLogin(payload);
  console.log(payload);
  if (res && res.meta && res.meta.statusCode === 200) {
    console.log("Res", res);
    // const value = { AUTH_INFO: res.data };
    await localStorage.setItem(
      "AUTH_INFO",
      JSON.stringify(res.data.user) || ""
    );

    await localStorage.setItem(
      "USER_TOKEN",
      JSON.stringify(res.data.token) || ""
    );
    await localStorage.setItem(
      "USER_ID",
      JSON.stringify(res.data.user.id) || ""
    );
    await localStorage.setItem("INFO_LOGIN", JSON.stringify(payload) || "");
    await dispatch(loginSuccess(res.data));
    // return {
    //   success: true,
    // };
  } else {
    await dispatch(loginFail(res.messages));
  }
  return res;
};

export const UserInfo = (payload) => async (dispatch) => {
  await dispatch(loginPending());
  const res = await OrderApi.getInfoUser();

  if (res && res.meta && res.meta.statusCode === 200) {
    console.log("Res", res);
    // const value = { AUTH_INFO: res.data };
    await localStorage.setItem(
      "AUTH_INFO",
      JSON.stringify(res.data.user) || ""
    );

    // await localStorage.setItem("USER_TOKEN", res.data.token || "");
    await localStorage.setItem("USER_ID", res.data.user.id || "");
    await dispatch(loginSuccess(res.data));
    // return {
    //   success: true,
    // };
  } else {
    await dispatch(loginFail(res.messages));
  }
  return res;
};

export const InfoUserOrderAction = (payload) => async (dispatch) => {
  await dispatch(userOrderPending());

  const res = await OrderApi.getOrderDetail(payload);

  if (res && res.meta && res.meta.statusCode === 200) {
    const data = res.data;
    let value = [];
    if (data?.length > 0) {
      let temp1 = data.map((x) => x.order_info);
      for (let i = 0; i < temp1.length; i++) {
        value = value.concat(temp1[i]);
        // console.log(c);
      }
    }

    let a = value.filter((x) => x.status !== 4);

    await dispatch(userOrderSuccess(a));
  } else {
    await dispatch(userOrderFail(res.messages));
  }
  return res;
};

export const SearchOrderAction = (payload) => async (dispatch) => {
  await dispatch(userOrderPending());
  await dispatch(searchOrderSuccess(payload));
};

export const resetOrderAction = (payload) => async (dispatch) => {
  await dispatch(userOrderPending());
  await dispatch(resetOrderSuccess());
};

export const deleteOrderAction = (payload) => async (dispatch) => {
  await dispatch(userOrderPending());

  const res = await OrderApi.cancelOrder(payload);
  if (res && res.meta && res.meta.statusCode === 200) {
    await dispatch(deleteOrderSuccess(payload));
    message.success("Hủy thành công");
  } else {
    await dispatch(userOrderFail(res.meta.msg));
    message.error("Hủy thất bại");
  }
};
export const updateTimeOrderAction = (payload) => async (dispatch) => {
  await dispatch(userOrderPending());
  // console.log(payload);
  const res = await OrderApi.updateTimeOrder(payload);
  console.log(res);
  if (res && res.meta && res.meta.statusCode === 200) {
    await dispatch(updateDateOrderSuccess(payload));
    message.success("Cập nhật thành công");
  } else {
    await dispatch(userOrderFail(res.meta.msg));
    message.error("Cập nhật thất bại");
  }
};
